export enum ContentLibraryEvent {
  DASHBOARD_VIEWED = 'ContentLibraryEvent:DASHBOARD_VIEWED',
  CONTENT_SOURCE_CLICKED = 'ContentLibraryEvent:CONTENT_SOURCE_CLICKED',
  REMOVE_FILE_CLICKED = 'ContentLibraryEvent:REMOVE_FILE_CLICKED',
  FILE_REMOVED = 'ContentLibraryEvent:FILE_REMOVED'
}
